import Vue from 'vue'
import App from './App.vue'
import router from './router'
import request from './utils/request'  // 导入封装的axios实例
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/common.less'

// 将封装的axios实例挂载到Vue原型上
Vue.prototype.$http = request

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app') 